import Singleton from '../Singleton';

export default class EncryptionService extends Singleton<EncryptionService> {
  /**
   * Public Methods
   */

  static encryptDecrypt(input: string, keyStr: string) {
    if (!keyStr || !input) {
      return input;
    }
    const output = [];
    const key = keyStr.split('');

    for (let i = 0; i < input.length; i += 1) {
      // eslint-disable-next-line no-bitwise
      const charCode = input.charCodeAt(i) ^ key[i % key.length].charCodeAt(0);
      output.push(String.fromCharCode(charCode));
    }
    return output.join('');
  }
}
